class ButtonToggle {
  constructor (button) {
    this.element = button
    this.label = this.element.querySelector('.js-button-label')
    this.stateElems = [...this.element.querySelectorAll('.js-state-wrapper')]
    this.buttonId = this.element.dataset.buttonid
    this.stateStore = JSON.parse(this.element.dataset.state)
    this.state = null

    this.setState(this.stateStore[0].name)

    this.init()
  }

  init() {
    this.element.addEventListener('click', () => {
      if (typeof this.onClick === 'function') {
        this.onClick(this.state, this.element, this)
      }
    })

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (typeof this.onVisibilityChange === 'function') {
          this.onVisibilityChange(entry.isIntersecting, this)
        }
      })
    })
    observer.observe(this.element)

    this.addToWindow()
  }

  setState(stateId) {
    if ('preload' in this.element.dataset) {
      this.element.removeAttribute('data-preload')
    }

    this.state = stateId

    this.stateElems.forEach(elem => {
      if (elem.dataset.stateid === this.state) {
        elem.classList.remove('unlocked-button__icon--hidden')
      } else {
        elem.classList.add('unlocked-button__icon--hidden')
      }
    })

    this.label.innerText = this.stateStore.find(item => item.name === this.state)?.label

    if (typeof this.onStateChange === 'function') {
      this.onStateChange(this.state, this.element, this)
    }
  }

  addToWindow() {
    if (!('toggleButtons' in window.unlocked)) {
      window.unlocked.toggleButtons = {}
    }

    window.unlocked.toggleButtons[this.buttonId] = this
  }

  // Events this button fires

  onClick = () => {}

  onVisibilityChange = () => {}

  onStateChange = () => {}
}

export default {
  selector: '.js-toggle-button',
  Source: ButtonToggle
}
